import { ANIMATION_DURATION } from '@optimus-web/common';
import { getDisableClickAwayProps } from '@optimus-web/helpers';
import { FadeInDelayed } from '../Transition';
import { AlertItem } from './AlertItem';
import { AlertTransitionGroup } from './style';
import { AlertContainerProps } from './types';

const Alerts = ({ alerts, closeButtonLabel, position, ...other }: AlertContainerProps) => (
    <AlertTransitionGroup
        position={position}
        timeoutExit={ANIMATION_DURATION.fast}
        {...other}
        {...getDisableClickAwayProps()}
    >
        {alerts.map((alert) => (
            <FadeInDelayed duration={ANIMATION_DURATION.fast} key={alert.id}>
                <AlertItem closeButtonLabel={closeButtonLabel} {...alert} />
            </FadeInDelayed>
        ))}
    </AlertTransitionGroup>
);

export default Alerts;
